var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 19.47,
    cy: 5.08,
    rx: 0.83,
    ry: 0.81,
    transform: "translate(10.7 23.19) rotate(-78.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.25,4.74c-.69-.67-2.57-2.3-5.51-2.81-3.29-.57-5.84.62-6.65,1.05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 12.19,
    cy: 21.41,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(-10.78 12.52) rotate(-39.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.71,21.3c.63-.04,4.43-.38,7.1-3.69,2.89-3.58,2.12-7.74,2-8.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.84,5.85c-.37.52-2.51,3.67-1.63,7.84.95,4.51,4.66,6.53,5.18,6.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 3.77,
    cy: 5.76,
    rx: 0.83,
    ry: 0.81,
    transform: "translate(-2.61 8.34) rotate(-78.79)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.79,13.83v-4.3c0-.38-.2-.73-.53-.92l-3.72-2.15c-.33-.19-.73-.19-1.06,0l-3.72,2.15c-.33.19-.53.54-.53.92v4.3c0,.38.2.73.53.92l3.72,2.15c.33.19.73.19,1.06,0l3.72-2.15c.33-.19.53-.54.53-.92Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 17.04,
    x2: 12,
    y2: 11.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 11.68,
    x2: 16.64,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.36,
    y1: 9,
    x2: 12,
    y2: 11.68
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlOps);
export default __webpack_public_path__ + "static/media/MLOps.e561b4aa877b1f419390f169a23025c6.svg";
export { ForwardRef as ReactComponent };